"use client";

import Link from "next/link";
import MenuItemLinks from "./NavDrawer/components/MenuItemLinks";
import MenubarAuth from "./NavDrawer/components/MenubarAuth";
import { useAuth } from "@/context/AuthContext";

export default function NavDrawer({ toggleDrawer }) {
  const { customer } = useAuth();

  return (
    <div className="bg-white h-full relative">
      <MenuItemLinks customer={customer} toggleDrawer={toggleDrawer} />
      <MenubarAuth customer={customer} toggleDrawer={toggleDrawer} />
    </div>
  );
}
